import { createContext } from 'react';

export const UserOnboardingContext = createContext({});
